import React from "react";
import DashboardPanel from "../components/dashboardPanel";

function DashboardPage() {
  return <DashboardPanel />;
}

DashboardPage.propTypes = {};
DashboardPage.defaultProps = {};

export default DashboardPage;
